var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$route.meta.hiddenPageHeader
    ? _c(
        "div",
        { staticClass: "pageheader" },
        [
          !_vm.$route.meta.hiddenBreadcrumb ? _c("Breadcrumb") : _vm._e(),
          !_vm.$route.meta.hiddenPageHeaderContent
            ? _c("div", { staticClass: "detail" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "action" }, [_vm._t("action")], 2)
                ])
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }